// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__874dT","a":"SocialMedia_a__B-Cmz"};